import { formatActivityDateAndTimes } from "web_myplann/Activities/Utils/formatActivityDateAndTimes";
import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { TimelineDateStyle } from "web_myplann/NotificationCenter/Types/TimelineDateStyle";
import { formatRelativeTimelineDate } from "web_myplann/NotificationCenter/Utils/formatTimelineDate";
import { formatTimelineSpacedDate } from "web_myplann/NotificationCenter/Utils/formatTimelineSpacedDate";
import { isResolvedActivityMovedToToday } from "web_myplann/NotificationCenter/Utils/isResolvedActivityMovedToToday";
import { parseActivityData } from "web_myplann/NotificationCenter/Utils/parseActivityData";

type TranslateFn = ReturnType<typeof useResource>["t"];

export const mapTimelineEntryDateLine = (
	item: TimelineItemResponseDTO,
	dateStyle: TimelineDateStyle,
	t: TranslateFn,
): string => {
	if (isResolvedActivityMovedToToday(item)) {
		return t(Resources.NotificationCenter.RecentGroups.Today);
	}

	if (item.category === TimelineItemCategoryEnum.Activity) {
		const timeTo = parseActivityData(item.data)?.timeTo;
		return formatActivityDateAndTimes(item.date, item.time, timeTo);
	}

	if (dateStyle === TimelineDateStyle.Relative) {
		return formatRelativeTimelineDate(item.date, new Date(), {
			today: t(Resources.Notifications.Date.today),
			yesterday: t(Resources.Notifications.Date.daysAgo, { count: 1 }),
			daysAgo: (count) => t(Resources.Notifications.Date.daysAgo, { count }),
			weeksAgo: (count) => t(Resources.Notifications.Date.weeksAgo, { count }),
			monthsAgo: (count) =>
				t(Resources.Notifications.Date.monthsAgo, { count }),
		});
	}

	return formatTimelineSpacedDate(item.date);
};
